<template>
  <el-drawer
    title="添加子母单标识"
    :visible.sync="drawer"
    direction="rtl"
    :before-close="handleClose"
    size="30%"
    :append-to-body="true"
  >
    <div class="zim_content">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="标识" prop="code">
          <el-input
            v-model="form.code"
            placeholder="请输入子母单标识"
            :maxlength="20"
          />
        </el-form-item>
        <el-form-item label="辅助说明" prop="name">
          <el-input
            v-model="form.name"
            placeholder="辅助说明标识的使用场景"
            :maxlength="50"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="drawer__footer">
      <el-button :loading="submitBtn" @click="handleClose">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="submitBtn"
        @click="handleSubmit"
      >
        保 存
      </el-button>
    </div>
  </el-drawer>
</template>

<script>
import { parentMarkCreate } from '@/views/shipperSeviceSetting/serveConfig/api';

export default {
  name: 'MultiPiecesEdit',
  data() {
    return {
      drawer: false,
      submitBtn: false,
      form: {},
      rules: {
        code: [
          { required: true, message: '请输入子母单标识', trigger: 'blur' },
          { pattern: /^((?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])|(\d)|([A-Za-z]))+$/, message: '请输入正确的标识', trigger: 'blur' },
        ],
      },
      customersDetail: {},
    };
  },
  methods: {
    show(customersDetail) {
      this.customersDetail = customersDetail;
      this.drawer = true;
    },
    handleClose() {
      this.form = {};
      this.drawer = false;
    },
    async handleSubmit() {
      await this.$refs.form.validate();
      this.submitBtn = true;
      const { ownerTenantId, customerCode } = this.customersDetail || {};
      try {
        await parentMarkCreate({
          customerCode,
          tenantId: ownerTenantId,
          markReqs: [this.form || {}],
        });
        this.$message.success('保存成功');
        this.$emit('refresh');
        this.handleClose();
        this.submitBtn = false;
      } catch (error) {
        this.submitBtn = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.zim_content{
  margin-bottom:64px;
}
.drawer__footer{
  height: 64px;
  width: calc(100% - 24px);
  border-top: 1px solid #EBEEF5;
  line-height: 64px;
  padding-right: 24px;
  text-align: right;
  position: absolute;
   background: #fff;
  bottom: 0;
  z-index:100
}
</style>
